import { Component } from '@angular/core';
import { MunilyTooltipPosition } from '../../../common-components/tooltip/tooltip.types';

@Component({
  selector: 'app-tooltip-playground',
  templateUrl: './tooltip-playground.component.html',
  styleUrls: ['./tooltip-playground.component.scss'],
})
export class TooltipPlaygroundComponent {
  text = 'Tooltip de ejemplo para UI Kit.';
  position: MunilyTooltipPosition = 'above';
  disabled = false;
  icon = 'info';
  readonly positions: MunilyTooltipPosition[] = ['above', 'below', 'left', 'right', 'before', 'after'];
}
